export * from "./tab-section.view";
